import { useState, useEffect } from "react";
import { FaStarOfLife } from "react-icons/fa";
import { toast } from "react-toastify";
import { AVAILABLE_COURSES, QIRAAT_RIWAYAT } from "../../components/Data/datas";



const QiraatCourseSelection = ({
  isHafiz,
  selectedCourse,
  handleCourseSelect,
  updateIt,
  location,
  setValue,
}) => {
  const [selectedRiwayat, setSelectedRiwayat] = useState(null);
  const [selectedPaymentOption, setSelectedPaymentOption] = useState(null);
  const [coursePrice, setCoursePrice] = useState(0);
  const [showRiwayatOptions, setShowRiwayatOptions] = useState(false);


  console.log("Current course price:", coursePrice);

  // Handle course selection
  const handleCourseSelection = (courseId) => {
    const course = AVAILABLE_COURSES.find((c) => c.id === courseId);

    // Check if course requires Hafiz status
    if (course.requiresHafiz && !isHafiz) {
      toast.error("Qira'at courses are only available for Hafiz students");
      return;
    }

    // Handle regular course selection
    handleCourseSelect(courseId);

    // If it's the Qira'at course, show riwayat options
    if (course.hasRiwayatOptions) {
      setShowRiwayatOptions(true);
      // Reset riwayat selection when switching to Qira'at course
      setSelectedRiwayat(null);
      setValue("riwayatId", null);
      setSelectedPaymentOption(null);
      setValue("paymentOptionType", null);
      setCoursePrice(0);
    } else {
      setShowRiwayatOptions(false);
    }
  };

  // Handle riwayat selection
  const handleRiwayatSelect = (riwayatId) => {
    setSelectedRiwayat(riwayatId);
    setValue("riwayatId", riwayatId);

    // Reset payment option when changing riwayat
    setSelectedPaymentOption(null);
    setValue("paymentOptionType", null);
    setCoursePrice(0);
  };

  // Handle payment option selection
  const handlePaymentOptionSelect = (paymentOptionType) => {
    setSelectedPaymentOption(paymentOptionType);
    setValue("paymentOptionType", paymentOptionType);
if (selectedRiwayat) {
  setValue("riwayatId", selectedRiwayat);
}
    // Update price based on selected riwayat and payment option
    if (selectedRiwayat) {
      const riwayat = QIRAAT_RIWAYAT.find((r) => r.id === selectedRiwayat);
      if (riwayat) {
        const paymentOption = riwayat.paymentOptions.find(
          (po) => po.type === paymentOptionType
        );
        if (paymentOption) {
          const newPrice =
            location === "nigeria"
              ? paymentOption.nigeriaPrice
              : paymentOption.diasporaPrice;

          setCoursePrice(newPrice);
           setValue("coursePrice", newPrice);

             if (typeof updateIt === 'function') {
          updateIt(newPrice, paymentOptionType, selectedRiwayat);
        }

          }
        }

    }
  };

  // Update price when location changes
  useEffect(() => {
    if (selectedRiwayat && selectedPaymentOption) {
      const riwayat = QIRAAT_RIWAYAT.find((r) => r.id === selectedRiwayat);
      if (riwayat) {
        const paymentOption = riwayat.paymentOptions.find(
          (po) => po.type === selectedPaymentOption
        );
        if (paymentOption) {
          const newPrice =
            location === "nigeria"
              ? paymentOption.nigeriaPrice
              : paymentOption.diasporaPrice;

          setCoursePrice(newPrice);

          // Also update the form value for price
          if (setValue) {
            setValue("coursePrice", newPrice);
          }
        }
      }
    }
  }, [location, selectedRiwayat, selectedPaymentOption, setValue]);

  // Get the selected riwayat details
  const getSelectedRiwayatDetails = () => {
    return QIRAAT_RIWAYAT.find((r) => r.id === selectedRiwayat) || null;
  };

  // Group riwayat by pricing category for better display
  const groupedRiwayat = {
    premium: QIRAAT_RIWAYAT.filter(
      (r) => r.paymentOptions[0].nigeriaPrice === 10000
    ),
    standard: QIRAAT_RIWAYAT.filter(
      (r) => r.paymentOptions[0].nigeriaPrice === 7000
    ),
    basic: QIRAAT_RIWAYAT.filter(
      (r) => r.paymentOptions[0].nigeriaPrice === 5000
    ),
  };

  return (
    <>
      {/* Course Selection */}
      <div className="mb-5 space-y-2">
        <div className="flex gap-1">
          <label htmlFor="course" className="text-sm text-slate-500">
            <i>Select a Course</i>
          </label>
          <FaStarOfLife className="text-[7px] mt-1 text-red-500" />
        </div>
        <div className="grid grid-cols-1 gap-4">
          {AVAILABLE_COURSES.map((course) => (
            <div
              key={course.id}
              className={`border rounded-lg p-4 cursor-pointer transition-all duration-200 ${
                selectedCourse === course.id
                  ? "border-green-500 bg-green-50"
                  : course.requiresHafiz && !isHafiz
                  ? "border-gray-200 bg-gray-100 opacity-60 cursor-not-allowed"
                  : "border-gray-200 hover:border-green-300"
              }`}
              onClick={() => {
                if (!(course.requiresHafiz && !isHafiz)) {
                  handleCourseSelection(course.id);
                }
              }}
            >
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-medium text-lg">{course.name}</h3>
                  <p className="text-sm text-gray-600">{course.description}</p>
                </div>
                <div className="text-right">
                  <p className="font-bold text-green-600">
                    {location === "nigeria" ? "₦" : "$"}
                    {location === "nigeria"
                      ? course.paymentOptions
                          .find((pay) => pay.type === "monthly")
                          .nigeriaPrice.toLocaleString()
                      : course.paymentOptions.find(
                          (pay) => pay.type === "monthly"
                        ).diasporaPrice}
                    {course.paymentOptions.find((pay) => pay.type === "monthly")
                      .type === "monthly" && (
                      <span className="text-xs text-gray-500 block">
                        /month
                      </span>
                    )}
                  </p>
                </div>
              </div>
              {course.requiresHafiz && (
                <p
                  className={`text-xs ${
                    isHafiz ? "text-amber-600" : "text-red-500"
                  } mt-2 font-medium`}
                >
                  Note: This advanced course requires Hafiz status.
                </p>
              )}
              {course.hasRiwayatOptions && isHafiz && (
                <p className="text-xs text-blue-600 mt-2 font-medium">
                  Multiple riwayat options available with different pricing.
                </p>
              )}
            </div>
          ))}
        </div>
        {!selectedCourse && (
          <p className="text-red-600 text-sm">Please select a course</p>
        )}
      </div>

      {/* Riwayat Selection (Only for Qira'at course) */}
      {showRiwayatOptions && selectedCourse === 3 && isHafiz && (
        <div className="mb-5 space-y-4">
          <div className="flex gap-1">
            <label htmlFor="riwayat" className="text-sm text-slate-500">
              <i>Select Riwayat (Recitation Method)</i>
            </label>
            <FaStarOfLife className="text-[7px] mt-1 text-red-500" />
          </div>

          {/* Premium Riwayat Options (10k/100k) */}
          <div className="space-y-2">
            <h4 className="font-medium text-amber-700">Premium Riwayat</h4>
            <div className="grid grid-cols-1 gap-2">
              {groupedRiwayat.premium.map((riwayat) => (
                <div
                  key={riwayat.id}
                  className={`border rounded-lg p-3 cursor-pointer ${
                    selectedRiwayat === riwayat.id
                      ? "border-amber-500 bg-amber-50"
                      : "border-gray-200 hover:border-amber-300"
                  }`}
                  onClick={() => handleRiwayatSelect(riwayat.id)}
                >
                  <div className="flex justify-between items-center">
                    <div>
                      <h4 className="font-medium">{riwayat.name}</h4>
                      <p className="text-xs text-gray-600">
                        {riwayat.description}
                      </p>
                    </div>
                    <div className="text-right">
                      <p className="font-bold text-amber-600">
                        {location === "nigeria" ? "₦" : "$"}
                        {location === "nigeria"
                          ? riwayat.paymentOptions[0].nigeriaPrice.toLocaleString()
                          : riwayat.paymentOptions[0].diasporaPrice}
                        <span className="text-xs text-gray-500 block">
                          /month
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Basic Riwayat Options (5k/50k) */}
          <div className="space-y-2">
            <h4 className="font-medium text-green-700">Standard Riwayat</h4>
            <div className="grid grid-cols-1 gap-2">
              {groupedRiwayat.basic.map((riwayat) => (
                <div
                  key={riwayat.id}
                  className={`border rounded-lg p-3 cursor-pointer ${
                    selectedRiwayat === riwayat.id
                      ? "border-green-500 bg-green-50"
                      : "border-gray-200 hover:border-green-300"
                  }`}
                  onClick={() => handleRiwayatSelect(riwayat.id)}
                >
                  <div className="flex justify-between items-center">
                    <div>
                      <h4 className="font-medium">{riwayat.name}</h4>
                      <p className="text-xs text-gray-600">
                        {riwayat.description}
                      </p>
                    </div>
                    <div className="text-right">
                      <p className="font-bold text-green-600">
                        {location === "nigeria" ? "₦" : "$"}
                        {location === "nigeria"
                          ? riwayat.paymentOptions[0].nigeriaPrice.toLocaleString()
                          : riwayat.paymentOptions[0].diasporaPrice}
                        <span className="text-xs text-gray-500 block">
                          /month
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Standard Riwayat Options (7k/70k) */}
          <div className="space-y-2">
            <h4 className="font-medium text-blue-700">Other Riwayat</h4>
            <div className="grid grid-cols-1 gap-2">
              {groupedRiwayat.standard.map((riwayat) => (
                <div
                  key={riwayat.id}
                  className={`border rounded-lg p-3 cursor-pointer ${
                    selectedRiwayat === riwayat.id
                      ? "border-blue-500 bg-blue-50"
                      : "border-gray-200 hover:border-blue-300"
                  }`}
                  onClick={() => handleRiwayatSelect(riwayat.id)}
                >
                  <div className="flex justify-between items-center">
                    <div>
                      <h4 className="font-medium">{riwayat.name}</h4>
                      <p className="text-xs text-gray-600">
                        {riwayat.description}
                      </p>
                    </div>
                    <div className="text-right">
                      <p className="font-bold text-blue-600">
                        {location === "nigeria" ? "₦" : "$"}
                        {location === "nigeria"
                          ? riwayat.paymentOptions[0].nigeriaPrice.toLocaleString()
                          : riwayat.paymentOptions[0].diasporaPrice}
                        <span className="text-xs text-gray-500 block">
                          /month
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {!selectedRiwayat && (
            <p className="text-red-600 text-sm">
              Please select a riwayat (recitation method)
            </p>
          )}
        </div>
      )}

      {/* Payment Option Selection - Only show if course and riwayat (if applicable) are selected */}
      {selectedCourse &&
        (!showRiwayatOptions || (showRiwayatOptions && selectedRiwayat)) && (
          <div className="mb-5 space-y-2">
            <div className="flex gap-1">
              <label htmlFor="paymentOption" className="text-sm text-slate-500">
                <i>Select Payment Option</i>
              </label>
              <FaStarOfLife className="text-[7px] mt-1 text-red-500" />
            </div>
            <div className="grid grid-cols-1 gap-3">
              {(selectedRiwayat
                ? getSelectedRiwayatDetails()?.paymentOptions || []
                : AVAILABLE_COURSES.find((c) => c.id === selectedCourse)
                    ?.paymentOptions || {}
              ).map((option) => (
                <div
                  key={option.type}
                  onClick={() => handlePaymentOptionSelect(option.type)}
                  className={`border p-3 rounded-lg cursor-pointer ${
                    selectedPaymentOption === option.type
                      ? "border-green-500 bg-green-50"
                      : "border-gray-200 hover:border-green-300"
                  }`}
                >
                  <div className="flex justify-between items-center">
                    <div>
                      <h4 className="font-medium">{option.label}</h4>
                    </div>
                    <div className="text-right">
                      <p className="font-bold text-green-600">
                        {location === "nigeria" ? "₦" : "$"}
                        {location === "nigeria"
                          ? option.nigeriaPrice.toLocaleString()
                          : option.diasporaPrice}
                      </p>
                      {option.type === "monthly" && (
                        <span className="text-xs text-gray-500">per month</span>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {!selectedPaymentOption && selectedCourse && (
              <p className="text-red-600 text-sm">
                Please select a payment option
              </p>
            )}
          </div>
        )}
    </>
  );
};

export default QiraatCourseSelection;
